'use client';

import React from 'react';
import { Card, ProfileCardHeader } from 'src/components';
import { useProfile } from 'src/context/providers/ProfileProvider';

const GroupPacDetails = () => {
  const { entityDetails } = useProfile();

  return (
    <Card className="p-6">
      <ProfileCardHeader
        icon={entityDetails?.type}
        title="Details"
        infoTooltip={true}
        tooltipView="physicianProfile"
      />
      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <span className="text-sm text-tertiary">Name</span>
          <span className="font-medium text-sm text-primary">
            {entityDetails?.name || 'Not available'}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-tertiary">Specialty</span>
          <span className="font-medium text-sm text-primary">
            {entityDetails?.description || 'Not available'}
          </span>
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-tertiary">PAC ID</span>
          <span className="font-medium text-sm text-primary">
            {entityDetails?.pac_id || 'Not available'}
          </span>
        </div>
      </div>
    </Card>
  );
};

export default GroupPacDetails;
